/**
 * Validates a value contains only alphanumeric characters and a set of special characters..
 * @param {any} value The value to validate.
 * @param {any} context Validation context
 * @return {Promise<string | null>} A promise that resolves to an error message, otherwise null
 * @name alphanumeric
 * @memberof combinators
 */
async function validate(value, context) {
  // always pass on a null input
  if (value === undefined || value === null || value === '') {
    return Promise.resolve(null);
  }

  const res = /^[a-zA-Z0-9 !@#%^&*()+':/=._-]+$/g.test(value);
  return Promise.resolve(res ? null : 'not-alphanumeric-special');
}

module.exports = validate;